import mapValues from "lodash/mapValues";
import pick from "lodash/pick";
import { BookingModuleStoreType, ColumnsDisplay, ColumnsType } from "PFApp/booking/store";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";

const getColumnsToPersist = (columns: Record<ColumnsType, ColumnsDisplay>) =>
  mapValues(columns, (columnsDisplay) => pick(columnsDisplay, "selectedColumns", "inlineColumns"));

export const getPartializedStoreToPersist = (state: BookingModuleStoreType) => {
  const workforceSlice = state[CalendarRoot.WorkforceProfiles];
  const engagementsSlice = state[CalendarRoot.ProjectsEngagements];
  const rolesSlice = state[CalendarRoot.ProjectsRoles];
  return {
    ...pick(state, "tab", "calendarMode", "calendarRootByMode", "isMisalignmentsVisible"),
    workforceMetrics: { mode: state.workforceMetrics.mode },
    [CalendarRoot.WorkforceProfiles]: {
      ...pick(workforceSlice, "pinnedIds", "view", "metric", "calendarGranularity", "bookingsVisibility"),
      order: { selectedOrder: workforceSlice.order.selectedOrder },
      columns: getColumnsToPersist(workforceSlice.columns)
    },
    [CalendarRoot.ProjectsEngagements]: {
      ...pick(engagementsSlice, "pinnedIds", "view", "isRoleLevelHidden", "engagementWallplannerMode"),
      order: { selectedOrder: engagementsSlice.order.selectedOrder },
      columns: getColumnsToPersist(engagementsSlice.columns)
    },
    [CalendarRoot.ProjectsRoles]: {
      ...pick(rolesSlice, "pinnedIds", "view"),
      order: { selectedOrder: rolesSlice.order.selectedOrder },
      columns: getColumnsToPersist(rolesSlice.columns)
    }
  };
};
